<mat-card
  matRipple
  class="item-card color {{ item.itemType }}"
  [ngClass]="{ 'cursor-pointer': !isDataLoading }"
  (click)="onCardClick()"
>
  <mat-card-header>
    <div mat-card-avatar>
      <mat-icon class="board-icon material-icons-outlined {{ item.itemCategory }} {{ item.itemType }}">
        {{ item.itemType === 'issue' ? 'assignment_late' : 'directions_run' }}
      </mat-icon>
    </div>
    <mat-card-title class="p-0 f-14 title">{{ item.name }}</mat-card-title>
    <mat-card-subtitle class="p-0 f-12 text-grey">{{ item.key }}</mat-card-subtitle>
    <div *ngIf="item.titleIcon?.icon" class="w-100 text-right">
      <mat-icon [ngClass]="item.titleIcon?.class">{{ item.titleIcon?.icon }}</mat-icon>
    </div>
  </mat-card-header>
  <mat-card-content>
    <mat-chip
      class="text-uppercase {{ item.itemCategory }}-category-color"
      *ngIf="item.itemCategoryName"
      matTooltip="{{ 'field.itemCategory' | translate }}"
      >{{ item.itemCategoryName }}
    </mat-chip>
  </mat-card-content>
  <mat-divider class="mt-1"></mat-divider>
  <mat-card-footer>
    <div class="row">
      <div class="col-4 m-auto">
        <app-inline-user-chip
          [name]="item.assigneeName!"
          [boardId]="item.boardId"
          [itemId]="item.id"
          (triggerRefresh)="triggerRefresh()"
          (click)="$event.stopPropagation()"
          ><app-text-avatar [text]="item.assigneeName!"></app-text-avatar>
        </app-inline-user-chip>
      </div>
      <div class="col-8 m-auto text-right">
        <app-inline-date-picker
          class="f-12 grey-text"
          *ngIf="item.dueDate; else createdAt"
          [itemId]="item.id"
          [date]="item.dueDate"
          (click)="$event.stopPropagation()"
          (triggerRefresh)="triggerRefresh()"
        >
          <app-due-date-table-cell
            [dueDate]="{ formatted: (item.dueDate! | utcToUserFormatted), original: item.dueDate! }"
            [doIgnoreDueDateCalculation]="item.statusCategory === 'done'"
          ></app-due-date-table-cell>
        </app-inline-date-picker>
      </div>
    </div>
  </mat-card-footer>
</mat-card>

<ng-template #createdAt>
  <span class="text-right h-100 grey-text f-12" matTooltip="{{ 'field.createdAt' | translate }}">
    <mat-icon>event</mat-icon>
    {{ item.createdAt | utcToUserFormatted }}
  </span>
</ng-template>
